<template>
  <div class="alert alert-danger alert-dismissible dialog" role="alert" v-show="showModal">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="click()">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="msg-box">{{ errorMessage }}</div>
  </div>
</template>
<script>
export default {
  props: ["errorMessage", "show"],
  data: () => {
    return {
      showModal: this.show
    };
  },
  methods: {
    click() {
      //func: 是父组件指定的传数据绑定的函数，this.msg:子组件给父组件传递的数据
      this.$emit("showModal", this.showModal);
    }
  },
  watch: {
    show (value){
      if(value){
        setTimeout(() => {
          this.click()
        },3000)
      }
    }
  }
};
</script>
<style scoped>
.dialog {
  text-align: center;
  height: max-content;
  position: fixed;
  left: 50%;
  top: 35%;
  transform: translate(-50%, -50%);
  width: 500px;
  z-index: 999;
  font-size: 16px;
}
.msg-box{color: #480404;}
</style>



// WEBPACK FOOTER //
// src/views/components/messageDialog.vue